export { MtcGameCoreModule } from './mtc-game-core.module';
export { MtcGameSelectorComponent } from './mtc-game-selector/mtc-game-selector.component';
export { MtcGameCoreService } from './mtc-game-core.service';
export { IMatchTheColumnGame } from './mtc-game.interface';
